"use client";

import React from "react";
import { CustomLink } from "../link/link.comp";
import { IFeaturePage } from "@/types";
import { ParallaxEditor } from "../parallax-editor/parallax-editor.comp";
import { StyledDiv } from "./featurePageHero.styles";
import Link from "next/link";
import { WidgetAiPrompt } from "../widgetAiPrompt/widgetAiPrompt.comp";

interface IFeaturePageHeroProps {
  page: IFeaturePage;
}

export const FeaturePageHero = ({ page }: IFeaturePageHeroProps) => {
  function renderCTA() {
    if (page.slug === 'ai' && page.customHero) {
      return (
        <>
          <WidgetAiPrompt />
          <p
            className="prompt-footer"
          >
            Already have a website? <Link href="/website-analyzer">Generate widget ideas based on your site</Link>
          </p>
        </>
      );
    }

    return (
      <CustomLink variant="gradient" href={page.buttonLink}>
        {page.buttonText}
      </CustomLink>
    );
  }

  return (
    <StyledDiv>
      <div className="hero-wrapper">
        <div className={`inner-wrapper ${page.slug === 'ai' ? 'ai-hero' : ''}`}>
          <h1>{page.title}</h1>
          <h2>{page.description}</h2>
          {renderCTA()}
        </div>
        {!page.customHero && (
          <div className="hero-img-wrapper">
            <ParallaxEditor
              contentImgSrc={page.heroImageLeft}
              hideContentImg={page.hideHeroImageLeft || false}
              contentImgStyle={page.contentImgStyle}
              editorContainerImgSrc={page.heroImage}
              editorContainerImgStyle={
                page.editorContainerImgStyle || { width: "90%" }
              }
              skinsImgSrc={page.heroImageRight}
              skinsImgStyle={page.skinsImgStyle}
              hideLayoutsImg={true}
              hideWidgetImg={true}
              wrapperStyle={{
                padding: "50px 0 0",
              }}
            />
          </div>
        )}
      </div>
    </StyledDiv>
  );
};
